import React, { useState, useRef } from "react";
import { addTeacher } from "../../../ApiController/teacherApi";
import "bootstrap/dist/css/bootstrap.min.css";

const AddTeacherForm = ({setDataChanged}) => {
	const [teacher, setTeacher] = useState({
		id: "",
		firstName: "",
		lastName: "",
		role: "",
	});
	const fileInputRef = useRef();

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setTeacher({ ...teacher, [name]: value });
	};

	function isValidName(name) {
		return /^[a-zA-Z]+$/.test(name);
	}

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (
			!isValidName(teacher.id) ||
			!isValidName(teacher.firstName) ||
			!isValidName(teacher.lastName)
		) {
			alert("Ogiltiga tecken för användarnamn.");
			return;
		}
		const formData = new FormData();
		formData.append("id", teacher.id);
		formData.append("firstName", teacher.firstName);
		formData.append("lastName", teacher.lastName);
		formData.append("role", teacher.role);

		if (fileInputRef.current.files[0]) {
			formData.append("image", fileInputRef.current.files[0]);
		}

		try {
			const response = await addTeacher(formData);

			alert(
				`Anställd tillagd med ID: ${teacher.id} och temporärt lösenord: ${response.defaultPassword}`
			);
			// Återställ formuläret och tillståndet
			setTeacher({
				id: "",
				firstName: "",
				lastName: "",
				role: "",
			});
			setDataChanged(true);
			fileInputRef.current.value = "";
		} catch (error) {
			if (error.response && error.response.data) {
				alert(
					`Misslyckades med att lägga till lärare: ${error.response.data.error}`
				);
			} else {
				console.error("Misslyckades med att lägga till lärare:", error);
				alert("Misslyckades med att lägga till lärare");
			}
		}
	};
	
	return (
		<div>
			<div className="d-flex justify-content-around mb-4 ">
				<div className="card custom-card-fixed-width">
					<div className="card-body ">
						<form onSubmit={handleSubmit}>
							<input
								type="text"
								name="id"
								placeholder="Lärar-ID"
								value={teacher.id}
								onChange={handleInputChange}
								className="form-control mb-2"
								required
							/>
							<input
								type="text"
								name="firstName"
								placeholder="Förnamn"
								value={teacher.firstName}
								onChange={handleInputChange}
								className="form-control mb-2"
								required
							/>
							<input
								type="text"
								name="lastName"
								placeholder="Efternamn"
								value={teacher.lastName}
								onChange={handleInputChange}
								className="form-control mb-2"
								required
							/>
							<select
								name="role"
								value={teacher.role}
								onChange={handleInputChange}
								className="form-select mb-2"
								required
							>
								<option value="">Välj Roll</option>
								<option value="admin">Admin</option>
								<option value="user">Lärare</option>
							</select>
							<div className="mb-2">
								<label htmlFor="image-upload" className="form-label">
									Bild
								</label>
								<input
									type="file"
									className="form-control mb-2"
									id="image-upload"
									ref={fileInputRef}
									onChange={handleInputChange}
									accept="image/*"
								/>
							</div>

							<button type="submit" className="btn btn-primary">
								Lägg till
							</button>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddTeacherForm;
